/* istanbul ignore file */
import type { ComponentClass } from 'react';
import React, { Fragment } from 'react';
import { Br } from '@alfa-bank/site-br';

// TODO: вынести в хелперы, так как он несовместим с helpers/hocs/parse-new-lines

export const parseArrayLines = (content: string | string[], WrapperComponent?: ComponentClass) => {
    const Component = WrapperComponent || Fragment;

    if (typeof content === 'string') {
        return <Component>{content.trim()}</Component>;
    }

    return content.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Component key={index}>
            {item.trim()}
            <Br />
        </Component>
    ));
};
